import React, { useState, useEffect } from 'react';
import { authService } from '../authService';
import notificationService from '../../../CommanService/notificationService';
import { useNavigate } from 'react-router-dom';
import closeEyes from '../../../assets/Icon/close-eyes.png';
import logoImage from '../../../assets/Icon/image.png';
import './NewPassword.css';
import { ReactComponent as FingerprintIcon } from '../../../assets/Icon/fingerprint_svgrepo.com.svg';


const NewPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userId, setUserId] = useState('');
  const [date, setDate] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Password rules
  const isLengthValid = password.length >= 8;
  const isCaseValid = /[a-z]/.test(password) && /[A-Z]/.test(password);
  const isNumberValid = /[0-9]/.test(password);
  const isSpecialValid = /[@$!%*#?&]/.test(password);

  useEffect(() => {
    // Parse query params from URL
    const params = new URLSearchParams(window.location.search);
    const rawUserId = params.get('userid') || '';
    const rawDate = params.get('date') || '';
    setUserId(rawUserId);
    setDate(rawDate);
  }, []);

  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();
    if (password !== confirmPassword) {
      notificationService.showWarning('New Password and Confirm Password do not match');
      return;
    }
    // Prepare payload
    const payload = {
      userid: userId,
      date: date,
      password: password
    };
    try {
      const response = await authService.ResetPassword(payload);
      console.log('ResetPassword API response:', response);
      if(response.success === true){
        notificationService.showSuccess(response.message);
        setTimeout(() => {
          navigate('/login');
        }, 2500);
      }
      else{
        notificationService.showError('Sorry..'+response.message);
      }
    } catch (err) {
      console.error('ResetPassword API error:', err);
    }
  };

  return (
    <div className="login_root">
      {/* Left Side */}
      <div className="login_left_side">
        <img 
          src={logoImage} 
          alt="Aesop Pricing Logo" 
          className="new-password-logo"
        />
        <h1 className="new-password-title">Hello,<br />AESOP PRICING!</h1>
        <p className="new-password-desc">
          Lorem ipsum dolor sit amet consectetur. Aliquam tortor fermentum egestas id pellentesque mi nec nibh amet. Congue laoreet commodo dui tempor venenatis vitae.
        </p>
        <div className="new-password-copyright">
           <span> 2025 AESOP. All rights reserved.</span>
        </div>
      </div>
      {/* Right Side */}
      <div className="login_right_side" >
        <form onSubmit={handleSubmit} className="login_card ">
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 16 }}>
              <div  className="fingerprint_img">
                <FingerprintIcon width={50} height={50} />
              </div>
            </div>
            <h2 style={{ textAlign: 'center', fontWeight: 700, fontSize: 32, margin: 0 }}>Reset Password</h2>
          </div>
          <div style={{ width: '100%', marginBottom: 16, position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              className="login_input" 
              placeholder="New Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              
              autoComplete="new-password"
            />
            <span
              style={{
                position: 'absolute',
                right: 10,
                top: 18,
                cursor: 'pointer',
                fontSize: 18,
                color: '#888',
                zIndex: 2
              }}
              onMouseEnter={() => setShowPassword(true)}
              onMouseLeave={() => setShowPassword(false)}
              tabIndex={0}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? '👁️' : <img src={closeEyes} alt="Hide password" style={{ width: 22, height: 22 }} />}
            </span>
            <div style={{ fontSize: 15, color: '#373123', margin: '8px 0 0 0', fontWeight: 500 }}>Password Must Contains :</div>
            <ul style={{ listStyle: 'none', padding: 0, margin: '8px 0 0 0', fontSize: 15 }}>
              <li style={{ color: isLengthValid ? '#4caf50' : '#888', marginBottom: 2 }}>
                <span style={{ marginRight: 6 }}>{isLengthValid ? '✔' : '✗'}</span>At least 8 characters
              </li>
              <li style={{ color: isCaseValid ? '#4caf50' : '#888', marginBottom: 2 }}>
                <span style={{ marginRight: 6 }}>{isCaseValid ? '✔' : '✗'}</span>Includes upper and lower case letters
              </li>
              <li style={{ color: isNumberValid ? '#4caf50' : '#888', marginBottom: 2 }}>
                <span style={{ marginRight: 6 }}>{isNumberValid ? '✔' : '✗'}</span>At least one number
              </li>
              <li style={{ color: isSpecialValid ? '#4caf50' : '#888' }}>
                <span style={{ marginRight: 6 }}>{isSpecialValid ? '✔' : '✗'}</span>At least one special character (@, $, !, %, etc.)
              </li>
            </ul>
          </div>
          <div style={{ width: '100%', marginBottom: 24, position: 'relative' }}>
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              className="login_input" 
              autoComplete="new-password"
            />
            <span
              style={{
                position: 'absolute',
                right: 10,
                top: 18,
                cursor: 'pointer',
                fontSize: 18,
                color: '#888',
                zIndex: 2
              }}
              onMouseEnter={() => setShowConfirmPassword(true)}
              onMouseLeave={() => setShowConfirmPassword(false)}
              tabIndex={0}
              aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
            >
              {showConfirmPassword ? '👁️' : <img src={closeEyes} alt="Hide password" style={{ width: 22, height: 22 }} />}
            </span>
          </div>
          <button type="submit" class="login-button">
            Reset Password
          </button>
          <div style={{ textAlign: 'center', color: '#888', fontSize: 16, marginTop: 8 }}>
            Don't want to change?{' '}
            <a href="/login" style={{ color: '#373123', fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}>Go to Login</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewPassword; 